module.exports = __webpack_public_path__ + "img/9_ward_15.1644dbcd.png";